import {
  secureDelete, secureGet, securePost, securePut,
} from 'config/apiConfig';

export const defaultMessage = 'Erreur système';
export const getUsers = async (page, filters) => {
  let url = `/users/GetMinimalClients?page=${page.page}&size=${page.size}`;
  Object.keys(filters).forEach((key) => {
    if (filters[key]) {
      url += `&${key}=${filters[key]}`;
    }
  });
  const { data } = await secureGet(url);
  return data;
};
export const deleteUser = async (id) => {
  const { data } = await secureDelete(`/users/delete/${id}`);
  return data;
};
export const addUser = async (user) => {
  const { data } = await securePut('/users/add', user);
  return data;
};
export const resetUserPassword = async (body) => {
  const { data } = await securePost('/users/password/reset', body);
  return data;
};
export const ChangeMyPassword = async (body) => {
  const { data } = await securePost('/users/password/change', body);
  return data;
};
export const getClients = async () => {
  const { data } = await secureGet('/users/GetMinimalClients');
  return data;
};
export const updateProfile = async (profile) => {
  const { data } = await securePost('/users/updateProfile', profile);
  return data;
};
export const getProfile = async () => {
  const { data } = await secureGet('/users/me');
  return data;
};
export const toggleClientStatus = async (clientCode) => {
  const { data } = await securePut(`/users/toggleClientStatus/${clientCode}`);
  return data;
};

export const getClientAccounts = async (clientCode) => {
  const { data } = await secureGet(`/users/clients/${clientCode}/accounts`);
  return data;
};

// MFA Management for Admin
export const enableUserMfa = async (userId) => {
  const { data } = await secureGet(`/mfa/admin/users/${userId}/enable`, {}, {}, false);
  return data;
};

export const disableUserMfa = async (userId) => {
  const { data } = await secureGet(`/mfa/admin/users/${userId}/disable`, {}, {}, false);
  return data;
};

export const getUserMfaStatus = async (userId) => {
  const { data } = await secureGet(`/mfa/admin/users/${userId}/status`);
  return data;
};

export const resetUserMfa = async (userId) => {
  const { data } = await secureGet(`/mfa/admin/users/${userId}/reset`, {}, {}, false);
  return data;
};

export const unlockUser = async (userId) => {
  const { data } = await securePut(`/users/${userId}/unlock`);
  return data;
};
